module.exports = __webpack_public_path__ + "img/public/SiteIcons/information-button.svg?9ec63647";